/*
 * View for KnowledgeBases
 */

define(["marionette", "modules/accountAdmin/kbAdmin/template/kbAdminTemplate.html"], function (
  Marionette,
  KbAdminTemplate,
) {
  var KbAdminView = {};

  KbAdminView.kbAdminLayout = Marionette.Layout.extend({
    template: KbAdminTemplate,
    triggers: {
      "click #addKb": "add:kb",
    },
    regions: {
      list: "#kbList",
    },
  });

  return KbAdminView;
});
